const isRegularLineItem = (lineItem) => "productImage" in lineItem && typeof lineItem.productImage !== "undefined";
const isContactLensesLineItem = (lineItem) => "type" in lineItem && lineItem.type === "CONTACT_LENSES";
const isGlassesBundleLineItem = (lineItem) => "type" in lineItem && lineItem.type === "GLASSES_BUNDLE";
const isNonPrescriptionBundleLineItem = (lineItem) => "type" in lineItem && lineItem.type === "NON_PRESCRIPTION_BUNDLE";
export {
  isContactLensesLineItem,
  isGlassesBundleLineItem,
  isNonPrescriptionBundleLineItem,
  isRegularLineItem
};
//# sourceMappingURL=line-items.js.map
